import store from "@/store";
import {sm2, sm4} from "sm-crypto";
import rsaEncrypt from "./rsaUtils";
import {encrypt, decrypt} from "./aesUtils";

export function publicEncrypt(data) {
    const publicKey = store.getters["User/publicKey"];
    let isGM = publicKey.algorithm === "SM";
    if (isGM) {
        return "04" + sm2.doEncrypt(data, publicKey);
    }
    return rsaEncrypt(data);
}

export function symmetricEncrypt(data, key) {
    const publicKey = store.getters["User/publicKey"];
    let isGM = publicKey.algorithm === "SM";
    if (isGM) {
        return sm4.encrypt(data, key);
    }
    return encrypt(key, data);
}

export function symmetricDecrypt(data, key) {
    const publicKey = store.getters["User/publicKey"];
    let isGM = publicKey.algorithm === "SM";
    if (isGM) {
        return sm4.decrypt(data, key);
    }
    return decrypt(key, data);
}
